import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1b9a1638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_2 = { class: "text-lg" }

import useAccess from "@/composable/useAccess";
	import { isFeatureKeyOn } from "@/composable/useEnterpriseFeature";
	import { userInfos } from "@/state/api/userState";
	import { storageConfig } from "@/state/api/userState";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenuLink',
  props: {
		title: {
			type: Object,
			default: {},
		},
		icon: {
			type: Object,
			default: {},
		},
		routeName: {
			type: String,
			default: "",
		},
		user_role: {
			type: Array,
			default: [],
		},
		userRoles: {
			type: Array,
			default: () => [],
		},
		featureFlag: {
			// Registry feature key gating this sub-item. Empty = no gate.
			type: String,
			default: "",
		},
		resources: {
			type: Array,
			default: [],
		},
		permissions: {
			type: Array,
			default: [],
		},
	},
  setup(__props) {

	const props = __props;

	const checkAccess = (resources: any) => {
		return  useAccess("resource", resources);
	}

	const checkRoles = (roles: any) => {
		if (!roles || (roles as any).length === 0) return true;
		return useAccess("visibility", roles);
	}


return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isFeatureKeyOn)(__props.featureFlag) && checkAccess(__props.resources) && checkRoles(__props.userRoles))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: __props.routeName },
        tag: "a",
        class: _normalizeClass([
			{
				'px-4 py-0 text-white rounded-md ': true,
				'font-normal  hover:text-accent  flex flex-row items-center justify-between': true,
			},
		])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.icon != {})
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  src: '/media/icons/circle-fill.svg',
                  css: "w-2 h-2",
                  class: "ml-4"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(storageConfig)?.lang ? __props.title[_unref(storageConfig).lang] : __props.title.en), 1)
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})